/**
 * @file 问一问统一日志统计功能函数
 * @author iknow-fe
 */
/* global App, getApp, Page, Component, Behavior, swan, getCurrentPages, requireDynamicLib */

import { request } from './request';
import { Logger } from '@baidu/knowledge-logger';
import { getSystemInfoSync } from './core';
const LOG_URL = 'https://power.baidu.com/m/static/common/ui/log/log.gif';
// 日志打点使用defer方式请求
// http://wiki.baidu.com/pages/viewpage.action?pageId=1283071412
let requestDefer = false;
const logRequest = (url, data = {}) => {
  let paramsArr = [];
  for (let key of Object.keys(data)) {
    paramsArr.push(key + '=' + data[key]);
  }

  // 在以defer方式请求的日志中，增加一个标识
  requestDefer && paramsArr.push('defer=1');
  imageReq(`${url}?${paramsArr.join('&')}`);
};

// 模块打点实例，存放全局key
const moduleLogger = new Logger({
  logUrl: LOG_URL,
  customRequest: logRequest
});
const sysInfo = getSystemInfoSync();
let gLogOpt = {
  pname: 'lvlin',
  appid: '16570201',
  ...sysInfo,
  'log_version': '2.0',
  'session_id': +new Date() + Math.random().toString().substring(2)
};
const beforeSend = (data, allKey) => {
  let {
    fromScene,
    zhishiSids
  } = getApp().globalData || {};
  let params = {
    t: +new Date(),
    fromScene
  };
  const sendData = {
    ...params,
    ...allKey,
    ...data,
    'zhishi_sids': zhishiSids
  };
  // 如果没有page，则获取当前页面page
  if (!sendData.page) {
    const nowPage = getCurrentPage();
    const pageArr = nowPage.uri ? nowPage.uri.split('/') : [];
    const pageName = pageArr[2] && pageArr[2] !== 'index' ? pageArr[2] : pageArr[1] || '';
    sendData.page = pageName;
    sendData.newlogGetCurrentPage = 1;
  }
  return sendData;
};

// 添加模块全局key
moduleLogger.addKey(gLogOpt);
moduleLogger.hook('beforeSend', beforeSend);

/**
 * 初始化page的打点实例
 * @param {Page} page 指定的Page实例
 * @returns {Logger}
 */

const initPageLogger = page => {
  const pageArr = page.uri ? page.uri.split('/') : [];
  const pageName = pageArr[2] && pageArr[2] !== 'index' ? pageArr[2] : pageArr[1] || '';
  const pageLogger = new Logger({
    logUrl: LOG_URL,
    customRequest: logRequest,
    parent: moduleLogger
  });
  pageLogger.addKey({
    page: pageName
  });
  pageLogger.hook('beforeSend', beforeSend);
  return pageLogger;
};

/**
 * 获取page下挂载的打点实例
 * @param {Page} page 指定的Page实例，默认从getCurrentPages取
 * @returns {Logger}
 */

const getPageLogger = page => {
  // 指定page或取当前page
  let targetPage = getCurrentPage(page);
  let pageLogger = targetPage._logger;
  if (!pageLogger || !(pageLogger instanceof Logger)) {
    pageLogger = initPageLogger(targetPage);
    targetPage._logger = pageLogger;
  }
  return pageLogger;
};

/**
 * @name send
 * @function
 * @description   发送统计请求
 * @param {Object} data {key:value}  统计项数据结构
 * @param {Object} option
 * @param {boolean} option.useLogKey 使用页面key
 * @param {boolean} option.page 指定page打点，useLogKey=false时不生效
 */

function send(data, option = {}) {
  let logger;
  let pagelogKey = {};
  // 如果useLogKey为false时，不用currentPage的logKey
  if (option.useLogKey === false) {
    logger = moduleLogger;
  } else {
    logger = getPageLogger(option.page);
    // 获取页面data.logKey，排除其中page属性
    const nowPage = getCurrentPage(option.page);
    pagelogKey = {
      ...(nowPage.data && nowPage.data.logKey || {})
    };
    delete pagelogKey.page;
  }
  logger && logger.send && logger.send({
    ...pagelogKey,
    ...data,
    module: 'h5-lvlin'
  });
}

/**
 * 新增全局统计key
 * @param {*} obj
 * */

function addGlobalKey(obj) {
  if (!obj) {
    return false;
  }
  delete obj.module;
  delete obj.page;
  delete obj.area;
  delete obj.action;
  delete obj.show;
  delete obj.exist;
  moduleLogger.addKey(obj);
}

/**
 * 新增page全局统计key
 * @param {*} obj
 * @param {Object} option
 * @param {boolean} option.page 指定page
 * */

function addKey(obj, option = {}) {
  if (!obj) {
    return false;
  }
  // 有代码addkey page，这里先保留page
  // delete obj.page;
  delete obj.module;
  delete obj.area;
  delete obj.action;
  delete obj.show;
  delete obj.exist;
  const pageLogger = getPageLogger(option.page);
  pageLogger.addKey(obj);

  // 回灌logKey到page.data上（旧log做切流实验，这段逻辑重复先注释）
  const nowPage = getCurrentPage(option.page) || {};
  nowPage.data = nowPage.data || {};
  nowPage.data.logKey = nowPage.data.logKey || {};
  Object.assign(nowPage.data.logKey, obj);
}

/**
 * 新增全局统计value
 * @param {*} obj
 * @param {Object} option
 * @param {boolean} option.page 指定page
 * */

function addValue(obj, option = {}) {
  if (!obj) {
    return false;
  }
  delete obj.module;
  delete obj.page;
  delete obj.area;
  delete obj.action;
  delete obj.show;
  delete obj.exist;
  const pageLogger = getPageLogger(option.page);
  pageLogger.addValue(obj);
}

/**
 * 新增全局统计value
 * @param {string} area
 * @param {Object} option
 * @param {boolean} option.page 指定page
 * */

function show(area, option = {}) {
  const pageLogger = getPageLogger(option.page);
  pageLogger.show(area);
}

/**
 * 新增全局统计value
 * @param {string} area
 * @param {Object} option
 * @param {boolean} option.page 指定page
 * */

function exist(area, option = {}) {
  const pageLogger = getPageLogger(option.page);
  pageLogger.exist(area);
}

/**
 * 获取当前页面
 * @param {Page} page 指定page
 */

function getCurrentPage(page) {
  if (page && page.uri) {
    return page;
  }
  const pages = getCurrentPages();
  const nowPage = pages[pages.length - 1] || {};
  return nowPage;
}
function imageReq(url) {
  let c = new Image();
  c.onload = c.onerror = function () {
    // 垃圾回收
    c = null;
  };
  c.src = url;
  c = null; // 垃圾回收
}

export default {
  send,
  addGlobalKey,
  addKey,
  addValue,
  show,
  exist,
  getPageLogger,
  log: imageReq
};